export default "__VITE_ASSET__MVHeUwK6__"